import "./App.css";
import AllPages from "./Pages/AllPages";

function App() {
  return (
    <div className="bg-light">
      <AllPages />
    </div>
  );
}

export default App;
